/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_Status_FailedInputs */

const en_admin_payments_status_failed = /** @type {(inputs: Admin_Payments_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed`)
};

const zh_admin_payments_status_failed = /** @type {(inputs: Admin_Payments_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`失败`)
};

/**
* | output |
* | --- |
* | "Failed" |
*
* @param {Admin_Payments_Status_FailedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_payments_status_failed = /** @type {((inputs?: Admin_Payments_Status_FailedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_Status_FailedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_payments_status_failed(inputs)
	return zh_admin_payments_status_failed(inputs)
});
export { admin_payments_status_failed as "admin.payments.status_failed" }